'use client';

import dynamic from 'next/dynamic';

const StickerCard = dynamic(() => import('./StickerCardSSR'), { ssr: false });

export default StickerCard;
